type Props = { count: number; disabled?: boolean; onUndo: () => void };

export function UndoButton({ count, disabled = false, onUndo }: Props) {
  return (
    <button
      type="button"
      className="grid-action"
      disabled={disabled || count === 0}
      onClick={onUndo}
      aria-label={`Undo last move, ${count} ${count === 1 ? 'move' : 'moves'} available`}
    >
      Undo <span>{count}</span>
    </button>
  );
}
